const segmentationTypes = {
  Day: 'Day',
  Week: 'Week',
  Month: 'Month',
  Quarter: 'Quarter',
  Year: 'Year',
  DayOfTheWeek: 'DayOfTheWeek',
  HourOfTheDay: 'HourOfTheDay',
  Device: 'DeviceType',
  Network: 'Network',
  TopVsOther: 'TopVsOther',
  GoalName: 'GoalName',
  GoalType: 'GoalType',
  AudienceName: 'AudienceName',
  AudienceType: 'AudienceType',
};

export default segmentationTypes;
